import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthData } from '@tesla/ng-auth';
import { TslDialog } from '@tesla/ng-tds';
import { AppSettings } from '../../../app.settings';
import { BankOtpConfirmationComponent } from 'app/profile/components/bank/bank-grid/bank-otp-confirmation/bank-otp-confirmation.component';
import { BaseService } from 'app/profile/services/base.service';
import { ConfirmationComponent } from 'app/shared/components/confirmation/confirmation.component';
import { deepfind, isCallBackRequired, isTokenEffective } from 'app/shared/utils/utils';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../index.service';
import {
    OTP_REDIRECT_TO,
    OTP_TOKEN
} from './otp.constants';

@Injectable()
export class OTPService extends BaseService {
    constructor(
        private http: HttpClient,
        private _router: Router, private config: AppSettings,
        private _storageService: LocalStorageService,
        private snackBar: MatSnackBar,
        private dialog: TslDialog,

    ) {
        super();
    }

    isAuthenticated(): boolean {
        const token = this._storageService.retrieve(OTP_TOKEN);
        return token && isTokenEffective(token);
    }

    requestAuthentication(_redirectTo: string) {
        const url = `${this.config.BaseUrl}Profile/MFA/GenerateOTP`;
        let headers = this.setHeaders();
        this.dialog.open(BankOtpConfirmationComponent, {
            maxWidth: '700px',
            data: {
                type: 'header',
                message: 'data'
            }
        }).afterClosed().subscribe((result) => {
            if (result) {
                return this.http.post(url, null, { headers }).subscribe((x: string) => {
                    if (x) {
                        this._storageService.store(OTP_REDIRECT_TO, _redirectTo);
                        window.location.assign(x);
                    }
                },
                (err) => {
                    let message = err && deepfind(err, 'error.error.message') ? deepfind(err, 'error.error.message') : `Something went wrong.`
                    this.snackBar.open(message, null, {
                        duration: 10000,
                        verticalPosition: 'top',
                        panelClass: ['red-snackbar']
                      });
                });
            }
        });
    }

    requestAuthenticationCallback() {
        const token = window.location.hash.substr(1);
        if(isCallBackRequired(token)){
            const url = `${this.config.BaseUrl}Profile/MFA/GetToken/${token}`;
            this.http.get(url).subscribe(res => {
                this.validateOTPTokenAndProcess(res["otpToken"]);
            });
        }else{
            this.validateOTPTokenAndProcess(token);
        }
    }

    validateOTPTokenAndProcess(token){
        const url = `${this.config.BaseUrl}Profile/MFA/ValidateOtpToken`;
        const isTokenValid = token && isTokenEffective(token);
        const redirectTo = this._storageService.retrieve(OTP_REDIRECT_TO);
        if (isTokenValid) {
            let headers = this.setHeaders();
            headers = headers.set(OTP_TOKEN, token);
            this.http.post(url, null, { headers }).subscribe((x: boolean) => {
                if (x) {
                    this._storageService.deleteFromStorage(OTP_REDIRECT_TO);
                    this._storageService.store(OTP_TOKEN, token);
                    window.location.href = `${window.location.protocol}//${window.location.hostname}/profile${redirectTo}`;
                } else {
                    this.resetOtpData();
                    this._router.navigate(['/auth/unauthorized']);
                }
            });

        } else {
            this.resetOtpData();
            this._router.navigate(['/auth/unauthorized']);
        }
    }


    resetOtpData(): void {
        this._storageService.deleteFromStorage(OTP_TOKEN);
    }

    private urlBase64Decode(str: string): string {
        let output = str.replace("-", "+").replace("_", "/");
        switch (output.length % 4) {
            case 0:
                break;
            case 2:
                output += "==";
                break;
            case 3:
                output += "=";
                break;
            default:
                throw new Error("Illegal base64url string!");
        }
        return window.atob(output);
    }
}
